<template>
  <div class="maintenance">
    <h1>Sito in manutenzione</h1>
    <p>Ci scusiamo per il disagio. Stiamo effettuando alcuni lavori di manutenzione. Torneremo presto online!</p>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
}
</script>

<style scoped>
.maintenance {
  text-align: center;
  margin-top: 20%;
  font-family: Arial, sans-serif;
}
</style>
